import axios from 'axios';

// ── Base URL ──────────────────────────────────────────────
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

// ── Attach token to every request ────────────────────────
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Auth ──────────────────────────────────────────────────
export const login  = (data) => API.post('/auth/login', data);
export const logout = ()     => API.post('/auth/logout');
export const getMe  = ()     => API.get('/auth/me');

// ── Employees ─────────────────────────────────────────────
export const getEmployees   = ()          => API.get('/employees');
export const getEmployee    = (id)        => API.get(`/employees/${id}`);
export const createEmployee = (data)      => API.post('/employees', data);
export const updateEmployee = (id, data)  => API.put(`/employees/${id}`, data);
export const deleteEmployee = (id)        => API.delete(`/employees/${id}`);

// ── Maintenance Records ───────────────────────────────────
export const getRecords     = ()          => API.get('/maintenance');
export const getRecord      = (id)        => API.get(`/maintenance/${id}`);
export const createRecord   = (data)      => API.post('/maintenance', data);
export const updateRecord   = (id, data)  => API.put(`/maintenance/${id}`, data);
export const deleteRecord   = (id)        => API.delete(`/maintenance/${id}`);

// ── Schools ───────────────────────────────────────────────
export const getSchools     = ()          => API.get('/schools');
export const getSchool      = (id)        => API.get(`/schools/${id}`);
export const createSchool   = (data)      => API.post('/schools', data);
export const updateSchool   = (id, data)  => API.put(`/schools/${id}`, data);
export const deleteSchool   = (id)        => API.delete(`/schools/${id}`);

export default API;